<template>
  <div class="crm-page">
    <div class="crm-hero">
      <div>
        <div class="crm-eyebrow">客户管理CRM</div>
        <h2>客户总览</h2>
        <p>
          从线索流入、员工表现、渠道分布到掉公海预警，一屏掌握 CRM 关键数据。
        </p>
      </div>
      <div class="crm-actions">
        <el-radio-group v-model="range" size="small" @change="renderCharts">
          <el-radio-button label="today">今日</el-radio-button>
          <el-radio-button label="week">本周</el-radio-button>
          <el-radio-button label="month">本月</el-radio-button>
        </el-radio-group>
        <el-button icon="el-icon-download" @click="notifyPending"
          >导出（待开发）</el-button
        >
      </div>
    </div>

    <div class="crm-stats">
      <div v-for="item in stats" :key="item.label" class="crm-stat">
        <div class="crm-stat-label">{{ item.label }}</div>
        <div class="crm-stat-value">{{ item.value }}</div>
      </div>
    </div>

    <el-row :gutter="16">
      <el-col :span="12">
        <el-card shadow="never">
          <div slot="header">客户转化漏斗</div>
          <div ref="funnel" class="chart-box"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="never">
          <div slot="header">来源渠道分布</div>
          <div ref="source" class="chart-box"></div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="16" style="margin-top: 16px">
      <el-col :span="12">
        <el-card shadow="never">
          <div slot="header">员工排行卡片</div>
          <div class="rank-list">
            <div
              v-for="(item, index) in rankList"
              :key="item.name"
              class="rank-item"
            >
              <div class="rank-left">
                <span class="rank-index">{{ index + 1 }}</span>
                <div>
                  <div class="rank-name">{{ item.name }}</div>
                  <div class="rank-meta">
                    有效沟通 {{ item.validCalls }} 次 · 今日签约
                    {{ item.signed }} 单
                  </div>
                </div>
              </div>
              <b>{{ item.score }}</b>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="never">
          <div slot="header">即将掉公海客户提醒</div>
          <div class="risk-list">
            <div
              v-for="item in urgentCustomers"
              :key="item.id"
              class="risk-item"
            >
              <div>
                <div class="risk-name">
                  {{ item.name }} / {{ item.companyName || "未填写公司" }}
                </div>
                <div class="risk-meta">
                  {{ item.mainStatus }} · {{ item.intentionLevel }} · 最近跟进
                  {{ item.lastFollowTime || "暂无" }}
                </div>
              </div>
              <el-tag
                :type="item.publicPoolCountdown <= 1 ? 'danger' : 'warning'"
                size="mini"
              >
                {{
                  item.publicPoolCountdown <= 0
                    ? "已超期"
                    : "剩余 " + item.publicPoolCountdown + " 天"
                }}
              </el-tag>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { loadCrmState } from "./mock";

export default {
  name: "CrmOverview",
  data() {
    return {
      range: "today",
      state: loadCrmState(this.$store.getters.GET_TITLE || "当前员工"),
      chartMap: {},
    };
  },
  computed: {
    snapshot() {
      return this.state.dashboardSnapshots[this.range] || {};
    },
    stats() {
      return [
        { label: "今日新增客户数", value: this.snapshot.newCustomers || 0 },
        { label: "今日拨打电话数", value: this.snapshot.calls || 0 },
        { label: "今日有效沟通数", value: this.snapshot.validCalls || 0 },
        { label: "今日加微信数", value: this.snapshot.wechatAdded || 0 },
        { label: "今日预约数", value: this.snapshot.appointments || 0 },
        { label: "今日签约数", value: this.snapshot.signed || 0 },
        { label: "今日转公海数", value: this.snapshot.toPublic || 0 },
        {
          label: "当前私人池客户数",
          value: this.state.customers.filter(
            (item) => item.poolType === "私人池"
          ).length,
        },
        {
          label: "当前公海池客户数",
          value: this.state.customers.filter(
            (item) => item.poolType === "公海池"
          ).length,
        },
        {
          label: "超期未跟进客户数",
          value: this.state.customers.filter(
            (item) => item.publicPoolCountdown <= 0
          ).length,
        },
      ];
    },
    rankList() {
      const owner = this.$store.getters.GET_TITLE || "当前员工";
      return [
        { name: owner, validCalls: 12, signed: 2, score: 96 },
        { name: "冯世丽", validCalls: 10, signed: 1, score: 89 },
        { name: "叶文婷", validCalls: 9, signed: 1, score: 83 },
        { name: "陈贞香", validCalls: 7, signed: 0, score: 76 },
      ];
    },
    urgentCustomers() {
      return this.state.customers
        .filter(
          (item) => item.poolType === "私人池" && item.publicPoolCountdown <= 2
        )
        .sort((a, b) => a.publicPoolCountdown - b.publicPoolCountdown);
    },
  },
  mounted() {
    this.renderCharts();
  },
  beforeDestroy() {
    Object.keys(this.chartMap).forEach((key) => {
      if (this.chartMap[key]) this.chartMap[key].dispose();
    });
  },
  methods: {
    notifyPending() {
      this.$message.warning("导出总览报表为待开发功能，当前仅演示 UI 和交互。");
    },
    renderCharts() {
      this.$nextTick(() => {
        this.renderFunnel();
        this.renderSource();
      });
    },
    getChart(refName) {
      if (!this.chartMap[refName] && this.$refs[refName]) {
        this.chartMap[refName] = echarts.init(this.$refs[refName]);
      }
      return this.chartMap[refName];
    },
    renderFunnel() {
      const chart = this.getChart("funnel");
      if (!chart) return;
      chart.setOption({
        tooltip: { trigger: "item" },
        series: [
          {
            type: "funnel",
            left: "10%",
            width: "80%",
            label: { color: "#1f2937" },
            itemStyle: { borderRadius: 8 },
            data: [
              { value: 286, name: "新录入" },
              { value: 198, name: "已接通" },
              { value: 132, name: "已加微信" },
              { value: 87, name: "已报价" },
              { value: 41, name: "已预约" },
              { value: 19, name: "已签约" },
            ],
          },
        ],
      });
    },
    renderSource() {
      const chart = this.getChart("source");
      if (!chart) return;
      chart.setOption({
        tooltip: { trigger: "item" },
        legend: { bottom: 0 },
        series: [
          {
            type: "pie",
            radius: ["40%", "68%"],
            data: this.state.analysisSeries.conversionBySource || [],
            label: { formatter: "{b}\n{d}%" },
          },
        ],
      });
    },
  },
};
</script>

<style scoped>
.crm-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.crm-hero {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  padding: 24px 28px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid #e8edf5;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.04);
}
.crm-eyebrow {
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(64, 158, 255, 0.12);
  color: #409eff;
  font-size: 12px;
  font-weight: 700;
}
.crm-hero h2 {
  margin: 12px 0 0;
  font-size: 28px;
  color: #111827;
}
.crm-hero p {
  margin: 10px 0 0;
  color: #6b7280;
  line-height: 1.7;
}
.crm-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.crm-stats {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 14px;
}
.crm-stat {
  padding: 18px;
  border-radius: 16px;
  background: #fff;
  border: 1px solid #e8edf5;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.03);
}
.crm-stat-label {
  font-size: 13px;
  color: #6b7280;
}
.crm-stat-value {
  margin-top: 8px;
  font-size: 28px;
  font-weight: 700;
  color: #111827;
}
.chart-box {
  height: 320px;
}
.rank-list,
.risk-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.rank-item,
.risk-item {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  padding: 14px 16px;
  border-radius: 14px;
  background: #f8fbff;
  border: 1px solid #edf2f7;
}
.rank-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.rank-index {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #111827;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
}
.rank-name,
.risk-name {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}
.rank-meta,
.risk-meta {
  margin-top: 4px;
  font-size: 12px;
  color: #6b7280;
}
@media (max-width: 1200px) {
  .crm-stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .crm-hero {
    flex-direction: column;
    align-items: flex-start;
  }
}
@media (max-width: 768px) {
  .crm-stats {
    grid-template-columns: 1fr;
  }
}
</style>
